import md5 from 'md5';
import { encodeToChars } from './encodeToChars';
import { getRandomString } from './getRandomString';

interface CreateSessionTokenOptions {
    nowUtc: string;
}

export const createSessionToken = ({ nowUtc }: CreateSessionTokenOptions) => {
    const random = getRandomString(8);
    return encodeToChars(`${random}${nowUtc || ''}`);
};

export const createSession = ({ sessionToken, clientName }: { sessionToken: string; clientName: string }) =>
    `${sessionToken}${md5(`${sessionToken}${clientName}`)}`.toUpperCase();
